import { airdrops } from "./airdrops/index.js";
import { lockup } from "./lockup/index.js";

export const releases = { airdrops, lockup };
